import React from 'react'

import { Text } from '../../../components/presentation/Text'
import { usePlaceTypes } from '../../../utils/helpers/placeTypes'
import ActivateQrcodeForm from './ActivateQrcodeForm'
import Center from '../../../components/helpers/Center'
import Loading from '../../../packages/kiti/components/helpers/Loading'
import Panel from '../../../components/structure/Panel'
import QrcodeLoader from '../_load/QrcodeLoader'
import Separator from '../../../components/helpers/Separator'
import SimpleAuthPageTemplate from '../../../components/templates/SimpleAuthPageTemplate'

const ActivateQrcode = ({ id }) => {
  // Load the placeTypes before enter the form
  const [_, { loading }] = usePlaceTypes()
  if (loading) return <Loading />

  return (
    <SimpleAuthPageTemplate title="Ativação QR Code">
      <Separator weight={4} />

      <QrcodeLoader id={id}>
        <Panel>
          <Center>
            <Text align="center" maxWidth={12}>
              Preencha o formulário abaixo para ativar o QR Code #{id}
            </Text>
          </Center>

          <Separator weight={4} />

          <ActivateQrcodeForm id={id} />
        </Panel>
      </QrcodeLoader>
    </SimpleAuthPageTemplate>
  )
}

export default ActivateQrcode
